import { render } from "./multiColumn.vue?vue&type=template&id=5ce06f5d&scoped=true"
import script from "./multiColumn.vue?vue&type=script&lang=js"
export * from "./multiColumn.vue?vue&type=script&lang=js"

import "./multiColumn.vue?vue&type=style&index=0&id=5ce06f5d&lang=scss&scoped=true"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce06f5d"]])

export default __exports__